import React from 'react';

import BackSettingsScreen from './BackSettingsScreen';
import { HistoryProps } from 'utils/history';

export default (props: HistoryProps) => (
  <BackSettingsScreen {...props} what="creative" />
);
